export default "__VITE_ASSET__dPsOnzOu__"